import styled from 'styled-components'

export const Wrapper = styled.a`
  margin: 25px 25px 0 0;
  display: inline-flex;
  cursor: pointer;
`
